import { Card } from 'react-bootstrap';
import { PageCardWrapper } from '../../../../sitel/demon/ui/atoms';
import { InputText } from '../../../../sitel/demon/ui/form';
import MedstarEntitiesDropdown from '../../../../sitel/demon/ui/organisms/formElements/medstarEntitiesDropdown';

export default function BoardMember({ register, errors }) {
  return (
    <PageCardWrapper title='Employment Information'>
      <Card.Body>
        <div className='row'>
          <div className='col-lg-6'>
            <MedstarEntitiesDropdown register={register} errors={errors} showIsRequired />
          </div>
          <div className='col-lg-6 mb-2'>
            <InputText labelText='MedStar Health department' id='department' placeholder='' showIsRequired maxlength='50' register={register} errors={errors} />
          </div>
          <div className='col-lg-6'>
            <InputText labelText='MedStar Health leader' id='leaderName' placeholder="Enter leader's first and last name" showIsRequired maxlength='100' register={register} errors={errors} />
          </div>
          <div className='col-lg-6'>
            <InputText labelText="Leader's email" id='leaderEmail' placeholder="Enter leader's email: @medstar.net @gunet.georgetown.edu @medstarmontgomery.org" showIsRequired maxlength='100' register={register} errors={errors} />
          </div>
        </div>
      </Card.Body>
    </PageCardWrapper>
  );
}
